import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-63a45826"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "optical-question",
  "aria-label": "黑盒光路推理题"
};
const _hoisted_2 = {
  class: "question-number"
};
const _hoisted_3 = {
  class: "known-cases",
  "aria-label": "已知案例"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "已知射入射出案例", -1));
const _hoisted_5 = {
  class: "board-grid"
};
const _hoisted_6 = {
  class: "target-path",
  "aria-label": "新射入路径"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "新射入路径", -1));
const _hoisted_8 = {
  key: 1,
  class: "image-block"
};
const _hoisted_9 = {
  key: 2,
  class: "option-block"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "hint"
}, "请选择新射入光线对应的射出路径", -1));
const _hoisted_11 = {
  key: 3,
  class: "review-panel"
};
const _hoisted_12 = {
  class: "review-result"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 1,
  class: "layout-answer"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "仪器内部结构", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OpticalPathBoard = _resolveComponent("OpticalPathBoard");
  const _component_el_image = _resolveComponent("el-image");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  return $props.data ? (_openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("header", null, [_createElementVNode("span", _hoisted_2, "第 " + _toDisplayString($props.data.questionIndex + 1) + " 题", 1), _createElementVNode("h2", null, _toDisplayString($props.data.title), 1)]), $options.hasStructuredConfig ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("section", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.opticalConfig.cases, (knownCase, index) => {
    return _openBlock(), _createElementBlock("figure", {
      key: index
    }, [_createVNode(_component_OpticalPathBoard, {
      "model-value": knownCase,
      compact: "",
      "show-elements": false,
      "aria-label": `已知案例 ${index + 1}`
    }, null, 8, ["model-value", "aria-label"]), _createElementVNode("figcaption", null, "案例 " + _toDisplayString(index + 1), 1)]);
  }), 128))])]), _createElementVNode("section", _hoisted_6, [_hoisted_7, _createVNode(_component_OpticalPathBoard, {
    "model-value": $props.data.opticalConfig.target,
    compact: "",
    "show-elements": false,
    "aria-label": "新射入路径"
  }, null, 8, ["model-value"])])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.questionImages, image => {
    return _openBlock(), _createBlock(_component_el_image, {
      key: image,
      src: image,
      "preview-src-list": $props.data.questionImages,
      fit: "contain"
    }, null, 8, ["src", "preview-src-list"]);
  }), 128))])), !$options.hasStructuredConfig && !$options.hasSeparateOptionImages ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.optionImages, image => {
    return _openBlock(), _createBlock(_component_el_image, {
      key: image,
      src: image,
      "preview-src-list": $props.data.optionImages,
      fit: "contain"
    }, null, 8, ["src", "preview-src-list"]);
  }), 128))])) : _createCommentVNode("", true), _hoisted_10, _createVNode(_component_AnswerButtonGroup, {
    options: $props.data.options || ['A', 'B', 'C', 'D'],
    review: $props.review,
    "review-mode": $props.reviewMode,
    onChoose: $options.onChoose
  }, _createSlots({
    _: 2
  }, [$options.hasStructuredConfig ? {
    name: "default",
    fn: _withCtx(({
      index
    }) => [_createVNode(_component_OpticalPathBoard, {
      class: "option-board",
      "model-value": $props.data.opticalConfig.options[index],
      compact: "",
      "show-elements": false,
      "aria-label": `选项 ${String.fromCharCode(65 + index)}`
    }, null, 8, ["model-value", "aria-label"])]),
    key: "0"
  } : $options.hasSeparateOptionImages ? {
    name: "default",
    fn: _withCtx(({
      index
    }) => [_createVNode(_component_el_image, {
      class: "option-image",
      src: $props.data.optionImages[index],
      "preview-src-list": $props.data.optionImages,
      fit: "contain"
    }, null, 8, ["src", "preview-src-list"])]),
    key: "1"
  } : undefined]), 1032, ["options", "review", "review-mode", "onChoose"]), $props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.rightAnswer), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass($props.review.result ? 'correct' : 'wrong')
  }, "你的答案：" + _toDisplayString($props.review.answer), 3)) : _createCommentVNode("", true)]), $props.data.analysisText ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString($props.data.analysisText), 1)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.analysisImages, image => {
    return _openBlock(), _createBlock(_component_el_image, {
      key: image,
      src: image,
      "preview-src-list": $props.data.analysisImages,
      fit: "contain"
    }, null, 8, ["src", "preview-src-list"]);
  }), 128)), $props.data.opticalConfig?.layout ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_hoisted_15, _createVNode(_component_OpticalPathBoard, {
    "model-value": $props.data.opticalConfig.layout,
    "show-arrow-slots": false,
    "aria-label": "仪器内部结构"
  }, null, 8, ["model-value"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}